export default "__VITE_ASSET__B$p93bX7__"